export enum UserType {
  deletion = 'deletion', // user that has a deletion token
  guest = 'guest', //	Guest user that has been created from onboarding
  onboarding = 'onboarding', // user that has begun onboarding process
  pulse = 'pulse', //	Pulse user that has been created from the system
  test = 'test', //	Test users in our system
  user = 'user', // Fully qualified user with an email
}
